import Office365Button from "./Office365Button";

export default Office365Button;
